import { useState } from "react";
import { toast } from "sonner";
import { Logo } from "./Logo";

export const Footer = () => {
  const [email, setEmail] = useState("");
  return (
    <footer className="relative border-t-2 border-[#FF4500] bg-[#111111]" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo className="h-9 w-auto" />
            <p className="mt-6 text-neutral-400 max-w-sm leading-relaxed">
              Heavyweight moto apparel built for the street, the dirt, and the
              open highway. Worn hard by riders everywhere.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-widest text-neutral-500 mb-4">
              Explore
            </h4>
            <ul className="space-y-3 text-sm text-neutral-300">
              {["Store", "The Standard", "Hall of Fame"].map((x) => (
                <li key={x} className="hover:text-[#FF4500] transition-colors cursor-pointer">
                  {x}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-widest text-neutral-500 mb-4">
              Join the Crew
            </h4>
            <div className="flex gap-2">
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email for drops"
                data-testid="newsletter-input"
                className="flex-1 bg-[#1a1a1a] border border-white/15 rounded-sm px-4 py-3 text-sm text-white outline-none focus:border-[#FF4500] transition-colors"
              />
              <button
                onClick={() => {
                  if (!email.includes("@")) return toast.error("Enter a valid email");
                  toast.success("You're on the list");
                  setEmail("");
                }}
                data-testid="newsletter-submit"
                className="bg-[#FF4500] text-white px-5 rounded-sm font-black uppercase text-xs tracking-wider hover:bg-white hover:text-black transition-colors"
              >
                Join
              </button>
            </div>
            <p className="text-[11px] text-neutral-500 mt-3 leading-snug">
              Drop your email to unlock exclusive product drops, VIP rider
              discounts, and local meet-up announcements.
            </p>
            <div
              className="mt-4 inline-flex items-center gap-3 bg-white rounded-sm px-3 py-2"
              data-testid="footer-qr-code"
              title="Scan to open 12-0clock.com"
            >
              <img
                src="/qr-12oclock.png"
                alt="QR code linking to 12-0clock.com"
                className="h-14 w-14"
              />
              <div className="text-black">
                <p className="text-[9px] font-black uppercase tracking-widest leading-tight">
                  Scan to visit
                </p>
                <p className="text-[10px] font-black uppercase tracking-wider leading-tight">
                  12-0clock.com
                </p>
              </div>
            </div>
            <div className="flex gap-4 mt-6 text-sm text-neutral-400">
              {["Instagram", "TikTok", "YouTube"].map((s) => (
                <span key={s} className="hover:text-[#FF4500] transition-colors cursor-pointer">
                  {s}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-neutral-600">
          <span>© {new Date().getFullYear()} 12 O'CLOCK. All rights reserved.</span>
          <div className="flex gap-6">
            <span className="hover:text-neutral-300 cursor-pointer">Privacy</span>
            <span className="hover:text-neutral-300 cursor-pointer">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
